import React, { useState, useEffect } from "react";
import "./styles/globals.css";
import ScrollReveal from "./components/ScrollReveal";
import CTAButton from "./components/CTAButton";
import SlotMachineIcon from "./components/Icons/SlotMachine";
import FootballIcon from "./components/Icons/Football";
import LightningIcon from "./components/Icons/Lightning";
import LockIcon from "./components/Icons/Lock";
import MoneyIcon from "./components/Icons/Money";
import DiamondIcon from "./components/Icons/Diamond";
import ChartIcon from "./components/Icons/Chart";
import PlayingCardIcon from "./components/Icons/PlayingCard";
import TrophyIcon from "./components/Icons/Trophy";
import BonusCard from "./components/BonusCard";
import CountUp from "./components/CountUp";
import BonusProgressBar from "./components/BonusProgressBar";
import CountdownTimer from "./components/CountdownTimer";
import ExitIntentPopup from './components/ExitIntentPopup';
import FloatingParticles from './components/FloatingParticles';
import Footer from './components/Footer';
import Header from './components/Header';
import LiveActivityFeed from './components/LiveActivityFeed';
import MediaMentions from './components/MediaMentions';
import SocialProof from './components/SocialProof';
import TrustBadges from './components/TrustBadges';



import {
    Box,
    Button,
    Flex,
    Image,
    SimpleGrid,
    Text,
    useColorModeValue,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Heading,
    Spacer,
    Icon,
    Grid,
    VStack,
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    AccordionIcon,
    useBreakpointValue,
    useColorMode,
    keyframes,
    Stack,
} from "@chakra-ui/react";
import {
    FaFacebook,
    FaGoogle,
    FaLine,
    FaTwitch,
    FaBasketballBall,
    FaBitcoin,
    FaDollarSign,
    FaTable,
    FaGamepad,
    FaHorseHead,
    FaStream,
    FaDice,
    FaBolt,
    FaGift,
    FaStar,
    FaRocket,
    FaCrown,
    FaTree,
    FaRedo,
} from "react-icons/fa";
import { GiCardJoker, GiConsoleController } from "react-icons/gi";
import { MdSportsSoccer } from "react-icons/md";
import { CgCardSpades } from "react-icons/cg";
import casinoImage from "./assets/img/casino-image.jpg";
import sportsImage from "./assets/img/sports-image.jpg";
import mastercardLogo from "./assets/img/mastercard-logo.png";
import applePayLogo from "./assets/img/apple-pay-logo.png";
import googlePayLogo from "./assets/img/google-pay-logo.png";
import samsungPayLogo from "./assets/img/samsung-pay-logo.jpg";
import { NavLink } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Leaderboard from "./Leaderboard";


import promotionalOne from "./assets/img/home/promotional-1.avif";
import promotionalSecond from "./assets/img/home/promotional-2_2.jpg";

import { Helmet } from "react-helmet";

// import {
//     FacebookIcon,
//     GoogleIcon,
//     TwitchIcon,
//     LineIcon,
// } from "./components/Icons/Icons";

import blueGradient from "./assets/svg/home/blue-gradient.svg";
import greenGradient from "./assets/svg/home/green-gradient.svg";

import blueGradientMobile from "./assets/svg/home/blue-gradient-mobile.svg";
import greenGradientMobile from "./assets/svg/home/green-gradient-mobile.svg";

import headerBg from "./assets/svg/home/header-background.svg";

import casinoBanner from "./assets/img/home/casino-banner.avif";
import sportsBanner from "./assets/img/home/sports-banner.avif";

import promotionsVideo from "./assets/video/home/promotions.webm";
import bonusVideo from "./assets/video/home/bonus.webm";
import returnToPlayerVideo from "./assets/video/home/return-to-player.webm";
import rafflesVideo from "./assets/video/home/raffles.webm";

import communityImage from "./assets/img/home/community.avif";

import currencyUsdtImage from "./assets/img/usdt.png";
import currencyBtcImage from "./assets/img/btc.png";
import currencyEthImage from "./assets/img/eth.png";
import currencyInrImage from "./assets/img/inr.png";

import billieJeanKingCupImage from "./assets/svg/home/horizontal-carousal/billie-jean-king-cup.svg";
import davisCupImage from "./assets/svg/home/horizontal-carousal/davis-cup.svg";
import drakeImage from "./assets/svg/home/horizontal-carousal/drake.svg";
import enyimbaFcImage from "./assets/svg/home/horizontal-carousal/enyimba-fc.svg";
import evertonImage from "./assets/svg/home/horizontal-carousal/everton.svg";
import juventudeImage from "./assets/svg/home/horizontal-carousal/juventude.svg";
import stakeF1Image from "./assets/svg/home/horizontal-carousal/stake-f1.svg";
import teamSecretImage from "./assets/svg/home/horizontal-carousal/team-secret.svg";
import ufcImage from "./assets/svg/home/horizontal-carousal/ufc.svg";

import blueBg from "./assets/svg/home/sponsorship/bg-blue.svg";
import greenBg from "./assets/svg/home/sponsorship/bg-green.svg";
import redBg from "./assets/svg/home/sponsorship/bg-red.svg";

import bettingPartnerImage from "./assets/img/home/other.png";
import mainPartnerImage from "./assets/img/home/promotional-2_2.jpg";
import titlePartnerImage from "./assets/img/home/title-partner.webp";

import bettingPartnerLogo from "./assets/svg/home/sponsorship/betting-partner-logo.svg";
import mainPartnerLogo from "./assets/svg/home/sponsorship/main-partner-logo.svg";
import titlePartnerLogo from "./assets/svg/home/sponsorship/title-partner-logo.svg";

import supportImage from "./assets/img/home/support.png";
import supportBg from "./assets/svg/home/supportBackground.svg";

import { useLinepros } from './useLinepros';
import { useLinepros1 } from './useLinepros1';

import { Global } from "@emotion/react";

export default function Index() {
    const { trackHeight } = useLinepros1();

    const { actions: { showJoin } } = useLinepros();
    const { actions: { showSports } } = useLinepros();
    const { actions: { showCasino } } = useLinepros();
    const { colorMode } = useColorMode();

    const isMobile = useBreakpointValue({ base: true, sm:true, msm:true, md: false, lg:false, xl:false, xxl:false });

    const [casinoBets, setCasinoBets] = useState([]);
    const [sportsBets, setSportsBets] = useState([]);
    const [leaderboard, setLeaderboard] = useState([]);

    const [hoverIndex, setHoverIndex] = useState(null);

    const bg = useColorModeValue("gray.100", "gray.900");
    const textColor = useColorModeValue("gray.700", "white");
    const iconColor = useColorModeValue("gray.600", "gray.300");
    const buttonColor = useColorModeValue("green.400");
    const secondaryTextColor = useColorModeValue("gray.400", "gray.400");
    const bgColor = useColorModeValue("white", "gray.800");
    const headerBgColor = useColorModeValue("gray.100", "gray.900");

    // CSS keyframes for continuous scroll effect
    const scroll = keyframes`
0% { transform: translateX(0); }
100% { transform: translateX(-100%); }
`;
    // Use different speeds for mobile and desktop
    const animationSpeed = useBreakpointValue({ base: "3s", md: "15s" });

    const imageSize = useBreakpointValue({ base: "60px", md: "100px" });
    const imageMargin = useBreakpointValue({ base: 10, md: 20 });

    useEffect(() => {
        trackHeight();
    }, [trackHeight]);

    // Simulate fetching data from an API
    useEffect(() => {
        const fetchCasinoBets = async () => {
            const data = [
                {
                    game: "Salon Privé Baccarat E",
                    user: "Hidden",
                    time: "7:09 PM",
                    betAmount: "4398.239824",
                    multiplier: "0.00x",
                    payout: "4398.239824",
                },
                {
                    game: "Speed Blackjack 22",
                    user: "Hidden",
                    time: "7:09 PM",
                    betAmount: "1999.199920",
                    multiplier: "0.00x",
                    payout: "-1999.199920",
                },
                {
                    game: "Salon Privé Baccarat E",
                    user: "Hidden",
                    time: "7:09 PM",
                    betAmount: "4398.239824",
                    multiplier: "0.00x",
                    payout: "4398.239824",
                },
                {
                    game: "Speed Blackjack 22",
                    user: "Hidden",
                    time: "7:09 PM",
                    betAmount: "1999.199920",
                    multiplier: "0.00x",
                    payout: "2999.199920",
                },
                // Add more dummy data here
            ];
            setCasinoBets(data);
        };

        const fetchSportsBets = async () => {
            const data = [
                {
                    event: "Basketball - Lakers vs Warriors",
                    user: "Hidden",
                    time: "7:30 PM",
                    odds: "1.95",
                    betAmount: "500",
                },
                {
                    event: "Football - Man Utd vs Liverpool",
                    user: "Hidden",
                    time: "8:00 PM",
                    odds: "2.10",
                    betAmount: "1000",
                },
                {
                    event: "Basketball - Lakers vs Warriors",
                    user: "Hidden",
                    time: "7:30 PM",
                    odds: "1.95",
                    betAmount: "500",
                },
                {
                    event: "Football - Man Utd vs Liverpool",
                    user: "Hidden",
                    time: "8:00 PM",
                    odds: "2.10",
                    betAmount: "1000",
                },
                // Add more dummy data here
            ];
            setSportsBets(data);
        };

        const fetchLeaderboard = async () => {
            const data = [
                { rank: 1, user: "Hidden", wagered: "10000", prize: "5000" },
                { rank: 2, user: "Hidden", wagered: "8000", prize: "4000" },
                { rank: 1, user: "Hidden", wagered: "10000", prize: "5000" },
                { rank: 2, user: "Hidden", wagered: "8000", prize: "4000" },
                // Add more dummy data here
            ];
            setLeaderboard(data);
        };

        fetchCasinoBets();
        fetchSportsBets();
        fetchLeaderboard();
    }, []);

    const bonuses = [
        {
            icon: FaBolt,
            label: "Bonus Boosts",
            description:
                "Weekly boosts and monthly bonuses for top games and sports betting.",
            video: bonusVideo,
        },
        {
            icon: FaStar,
            label: "Raffles & Races",
            description:
                "Participate in exciting raffles and races to win big rewards.",
            video: rafflesVideo,
        },
        {
            icon: FaGift,
            label: "Promotions",
            description: "Special promotions offering fantastic rewards and bonuses.",
            video: promotionsVideo,
        },
        {
            icon: FaBitcoin,
            label: "High Return-to-Player (RTP)",
            description: "Up to 99.5% RTP in selected games for more chances to win.",
            video: returnToPlayerVideo,
        },
    ];

    const [selectedVideo, setSelectedVideo] = useState(bonuses[0].video);
    const [progress, setProgress] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        // Set interval to change video every 10 seconds (10000 milliseconds)
        const interval = setInterval(() => {
            const nextIndex = (currentIndex + 1) % bonuses.length;
            setCurrentIndex(nextIndex);
            setSelectedVideo(bonuses[nextIndex].video);
            setProgress(0); // Reset progress
        }, 10000);

        // Update progress every second
        const progressInterval = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 100) {
                    return 0; // Reset progress when complete
                }
                return prevProgress + 1;
            });
        }, 100); // Update every 100 milliseconds

        return () => {
            clearInterval(interval);
            clearInterval(progressInterval);
        };
    }, [currentIndex]);

    const receivedBonuses = [
        "Weekly Bonus Received",
        "Monthly Bonus Received",
        "VIP Bonus Received",
        "Level-up Bonus Received",
        "Casino Bonus Received",
    ];

    const horizontalImages = [
        billieJeanKingCupImage,
        davisCupImage,
        drakeImage,
        enyimbaFcImage,
        evertonImage,
        juventudeImage,
        stakeF1Image,
        teamSecretImage,
        ufcImage,
    ];

    const verticalImages = [
        currencyUsdtImage,
        currencyBtcImage,
        currencyEthImage,
        currencyInrImage,
    ];

    const verticalSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        rtl: true,
        pauseOnHover: false,
    };

    const sponsorshipData = [
        {
            headerText: "F1",
            // title: "Wager Street F1 Team Kick Sauber",
            backgroundImage: greenBg,
            image: titlePartnerImage,
            // logo: titlePartnerLogo,
            // description: "Exclusive Title Partner",
            // buttonText: "Learn more",
        },
        {
            headerText: "Official Betting Partner",
            // title: "UFC Official Betting Partner",
            backgroundImage: redBg,
            image: bettingPartnerImage,
            // logo: bettingPartnerLogo,
            // description:
            //   "Our ground-breaking partnership with the UFC provides an unmatched betting experience...",
            // buttonText: "Learn more",
        },
        {
            headerText: "Main Partner",
            // title: "Main Partner Everton",
            backgroundImage: blueBg,
            image: mainPartnerImage,
            // logo: mainPartnerLogo,
            // description: "Main Partner with Everton",
            // buttonText: "Learn more",
        },
    ];

    return (
        <>
            <Helmet>
                {/* GTM en <head> */}
                <script>
                    {`
            (function(w,d,s,l,i){w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-K32LWXGQ');
          `}
                </script>
            </Helmet>

            {/* GTM después del <body> (noscript) */}
            <noscript>
                <iframe
                    src="https://www.googletagmanager.com/ns.html?id=GTM-K32LWXGQ"
                    height="0"
                    width="0"
                    style={{ display: "none", visibility: "hidden" }}
                />
            </noscript>
            <Global
                styles=
                    {`
              html, body {
                height: 100%;
                margin: 0;
                padding: 0;
                overflow-y: hidden;
              }
            `}
            />

            <Flex
                flexDirection="column"
                pt={{ base: "120px", md: "65px" }}
                px={{ base: 4, md: 8 }}
                bg={bg}
                color={textColor}
                minHeight="100vh"
            >
                <style dangerouslySetInnerHTML={{ __html: `
                .table-wrapper {
                  overflow-x: auto;
                  -webkit-overflow-scrolling: touch;
                }
                @media (max-width: 600px) {
                    .hide-mobile {
                      display: none;
                    }
                }
                .css-1sw76us {
                    padding-top: 0px !important;
                }
            ` }} />

                <main className="min-h-screen">
                    {/* PREMIUM FEATURES SECTION - Sports Betting with Background */}
                    <section className="relative py-20 border-b border-wager-green/30 overflow-hidden">
                        {/* Background Image with Overlay */}
                        <div
                            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                            style={{
                                backgroundImage: 'url("/football-hero.jpg")',
                            }}
                        >
                            {/* Multiple overlay layers for professional blending */}
                            <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/85 to-slate-900/70"></div>
                            <div className="absolute inset-0 bg-gradient-to-b from-slate-900/20 via-transparent to-slate-900/40"></div>
                            <div className="absolute inset-0 backdrop-blur-[2px]"></div>
                        </div>

                        {/* Content */}
                        <div className="relative z-10 container mx-auto px-4">
                            <div className="grid lg:grid-cols-2 gap-12 items-center">
                                {/* Left: Text Content */}
                                <ScrollReveal direction="left" delay={0}>
                                    <div>
                                        <div className="inline-block bg-wager-green/20 px-4 py-2 rounded-full mb-6">
                                            <span className="text-wager-green font-semibold">SPORTS BETTING</span>
                                        </div>
                                        <h2 className="text-5xl font-bold text-white mb-6 leading-tight">
                                            Bet On Every Major League
                                        </h2>
                                        <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                                            Get instant access to NFL, NBA, MLB, NHL, Soccer, and 100+ sports events. Real-time odds updates, live betting, and expert analysis to maximize your winning potential.
                                        </p>
                                        <div className="space-y-4 mb-8">
                                            <div className="flex items-start gap-4">
                                                <div className="text-wager-green text-2xl mt-1">✓</div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">Live Betting</h4>
                                                    <p className="text-gray-400">Place bets in real-time as the action unfolds</p>
                                                </div>
                                            </div>
                                            <div className="flex items-start gap-4">
                                                <div className="text-wager-green text-2xl mt-1">✓</div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">Best Odds Guarantee</h4>
                                                    <p className="text-gray-400">Competitive lines across all major sports</p>
                                                </div>
                                            </div>
                                            <div className="flex items-start gap-4">
                                                <div className="text-wager-green text-2xl mt-1">✓</div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">Parlay Builder</h4>
                                                    <p className="text-gray-400">Create custom multi-leg bets with enhanced payouts</p>
                                                </div>
                                            </div>
                                        </div>
                                        <CTAButton text="Explore Sports Betting" />
                                    </div>
                                </ScrollReveal>

                                {/* Right: Visual Stats */}
                                <ScrollReveal direction="right" delay={200}>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="bg-wager-green/10 border border-wager-green/30 rounded-2xl p-8 text-center hover:bg-wager-green/20 transition-colors">
                                            <div className="text-4xl font-bold text-wager-green mb-2">500+</div>
                                            <div className="text-gray-300">Daily Events</div>
                                        </div>
                                        <div className="bg-wager-green/10 border border-wager-green/30 rounded-2xl p-8 text-center hover:bg-wager-green/20 transition-colors">
                                            <div className="text-4xl font-bold text-wager-green mb-2">1M+</div>
                                            <div className="text-gray-300">Monthly Bets</div>
                                        </div>
                                        <div className="bg-wager-green/10 border border-wager-green/30 rounded-2xl p-8 text-center hover:bg-wager-green/20 transition-colors">
                                            <div className="text-4xl font-bold text-wager-green mb-2">24/7</div>
                                            <div className="text-gray-300">Live Support</div>
                                        </div>
                                        <div className="bg-wager-green/10 border border-wager-green/30 rounded-2xl p-8 text-center hover:bg-wager-green/20 transition-colors">
                                            <div className="text-4xl font-bold text-wager-green mb-2">50+</div>
                                            <div className="text-gray-300">Leagues</div>
                                        </div>
                                    </div>
                                </ScrollReveal>
                            </div>
                        </div>
                    </section>

                    {/* PREMIUM FEATURES SECTION - Casino Gaming with Background */}
                    <section className="relative py-20 border-b border-wager-blue/30 overflow-hidden">
                        {/* Background Image with Overlay */}
                        <div
                            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                            style={{
                                backgroundImage: 'url("/casino-hero.jpg")',
                            }}
                        >
                            {/* Multiple overlay layers for professional blending */}
                            <div className="absolute inset-0 bg-gradient-to-r from-slate-800 via-slate-900/85 to-slate-900/70"></div>
                            <div className="absolute inset-0 bg-gradient-to-b from-slate-800/20 via-transparent to-slate-800/40"></div>
                            <div className="absolute inset-0 backdrop-blur-[2px]"></div>
                        </div>

                        {/* Content */}
                        <div className="relative z-10 container mx-auto px-4">
                            <div className="grid lg:grid-cols-2 gap-12 items-center">
                                {/* Left: Visual Stats (reversed on mobile) */}
                                <ScrollReveal direction="left" delay={200}>
                                    <div className="grid grid-cols-2 gap-4 order-2 lg:order-1">
                                        <div className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-2xl p-8 text-center hover:bg-white/20 hover:border-white/50 transition-all">
                                            <div className="text-4xl font-bold text-white mb-2">8,000+</div>
                                            <div className="text-gray-200 font-medium">Games</div>
                                        </div>
                                        <div className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-2xl p-8 text-center hover:bg-white/20 hover:border-white/50 transition-all">
                                            <div className="text-4xl font-bold text-white mb-2">200+</div>
                                            <div className="text-gray-200 font-medium">Providers</div>
                                        </div>
                                        <div className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-2xl p-8 text-center hover:bg-white/20 hover:border-white/50 transition-all">
                                            <div className="text-4xl font-bold text-white mb-2">$5B+</div>
                                            <div className="text-gray-200 font-medium">Paid Out</div>
                                        </div>
                                        <div className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-2xl p-8 text-center hover:bg-white/20 hover:border-white/50 transition-all">
                                            <div className="text-4xl font-bold text-white mb-2">100%</div>
                                            <div className="text-gray-200 font-medium">Fair Games</div>
                                        </div>
                                    </div>
                                </ScrollReveal>

                                {/* Right: Text Content */}
                                <ScrollReveal direction="right" delay={0}>
                                    <div className="order-1 lg:order-2">
                                        <div className="inline-block bg-wager-blue/20 px-4 py-2 rounded-full mb-6">
                                            <span className="text-white font-semibold">CASINO GAMING</span>
                                        </div>
                                        <h2 className="text-5xl font-bold text-white mb-6 leading-tight">
                                            Thousands of Games, Infinite Wins
                                        </h2>
                                        <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                                            Access premium slots, table games, and live dealers from the world's leading game studios. Experience cutting-edge graphics, immersive gameplay, and massive jackpots.
                                        </p>
                                        <div className="space-y-4 mb-8">
                                            <div className="flex items-start gap-4">
                                                <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-wager-blue to-wager-blue/80 flex items-center justify-center">
                                                    <span className="text-white font-bold text-lg">✓</span>
                                                </div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">Live Dealers</h4>
                                                    <p className="text-gray-400">Interactive gaming with professional dealers in HD</p>
                                                </div>
                                            </div>
                                            <div className="flex items-start gap-4">
                                                <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-wager-blue to-wager-blue/80 flex items-center justify-center">
                                                    <span className="text-white font-bold text-lg">✓</span>
                                                </div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">Progressive Jackpots</h4>
                                                    <p className="text-gray-400">Win life-changing amounts on select games</p>
                                                </div>
                                            </div>
                                            <div className="flex items-start gap-4">
                                                <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-wager-blue to-wager-blue/80 flex items-center justify-center">
                                                    <span className="text-white font-bold text-lg">✓</span>
                                                </div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">Tournament Mode</h4>
                                                    <p className="text-gray-400">Compete with other players for real prizes</p>
                                                </div>
                                            </div>
                                        </div>
                                        <CTAButton text="Play Casino Games" />
                                    </div>
                                </ScrollReveal>
                            </div>
                        </div>
                    </section>

                    {/* PREMIUM FEATURES SECTION - Crypto & Security */}
                    <section className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 border-b border-purple-500/30">
                        <div className="container mx-auto px-4">
                            <div className="grid lg:grid-cols-2 gap-12 items-center">
                                {/* Left: Text Content */}
                                <ScrollReveal direction="left" delay={0}>
                                    <div>
                                        <div className="inline-block bg-purple-500/20 px-4 py-2 rounded-full mb-6">
                                            <span className="text-purple-400 font-semibold">CRYPTO & WEB3</span>
                                        </div>
                                        <h2 className="text-5xl font-bold text-white mb-6 leading-tight">
                                            The Future of Gaming
                                        </h2>
                                        <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                                            Deposit and withdraw using Bitcoin, Ethereum, USDT, and other cryptocurrencies. Experience instant transactions, lower fees, and maximum anonymity with our blockchain-verified gaming.
                                        </p>
                                        <div className="space-y-4 mb-8">
                                            <div className="flex items-start gap-4">
                                                <div className="text-purple-400 text-2xl mt-1">✓</div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">Instant Deposits</h4>
                                                    <p className="text-gray-400">Crypto transactions settle in minutes</p>
                                                </div>
                                            </div>
                                            <div className="flex items-start gap-4">
                                                <div className="text-purple-400 text-2xl mt-1">✓</div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">Provably Fair</h4>
                                                    <p className="text-gray-400">Verify every game outcome on the blockchain</p>
                                                </div>
                                            </div>
                                            <div className="flex items-start gap-4">
                                                <div className="text-purple-400 text-2xl mt-1">✓</div>
                                                <div>
                                                    <h4 className="text-white font-semibold mb-1">20+ Cryptocurrencies</h4>
                                                    <p className="text-gray-400">Bet in your favorite digital assets</p>
                                                </div>
                                            </div>
                                        </div>
                                        <CTAButton text="Start with Crypto" />
                                    </div>
                                </ScrollReveal>

                                {/* Right: Visual Stats */}
                                <ScrollReveal direction="right" delay={200}>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="bg-purple-500/10 border border-purple-500/30 rounded-2xl p-8 text-center hover:bg-purple-500/20 transition-colors">
                                            <div className="text-4xl font-bold text-purple-400 mb-2">20+</div>
                                            <div className="text-gray-300">Crypto Assets</div>
                                        </div>
                                        <div className="bg-purple-500/10 border border-purple-500/30 rounded-2xl p-8 text-center hover:bg-purple-500/20 transition-colors">
                                            <div className="text-4xl font-bold text-purple-400 mb-2">0%</div>
                                            <div className="text-gray-300">Deposit Fee</div>
                                        </div>
                                        <div className="bg-purple-500/10 border border-purple-500/30 rounded-2xl p-8 text-center hover:bg-purple-500/20 transition-colors">
                                            <div className="text-4xl font-bold text-purple-400 mb-2">100%</div>
                                            <div className="text-gray-300">Transparent</div>
                                        </div>
                                        <div className="bg-purple-500/10 border border-purple-500/30 rounded-2xl p-8 text-center hover:bg-purple-500/20 transition-colors">
                                            <div className="text-4xl font-bold text-purple-400 mb-2">SSL</div>
                                            <div className="text-gray-300">Encrypted</div>
                                        </div>
                                    </div>
                                </ScrollReveal>
                            </div>
                        </div>
                    </section>

                    {/* HERO BANNER - Campaign Selection */}
                    <section className="bg-gradient-to-b from-slate-800 to-slate-900 py-20">
                        <div className="container mx-auto px-4">
                            <ScrollReveal direction="up" delay={0}>
                                <div className="text-center mb-16">
                                    <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
                                        Exclusive Welcome Bonuses
                                    </h2>
                                    <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                                        Choose from six premium bonus packages tailored to your playing style
                                    </p>
                                </div>
                            </ScrollReveal>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                                {/* Casino/Sports */}
                                <div className="group">
                                    <a href="/casino-sports" className="block h-full">
                                        <div className="h-full bg-gradient-to-br from-slate-700 to-slate-800 rounded-2xl p-10 border border-wager-green/30 hover:border-wager-green/60 transition-all duration-300 hover:shadow-2xl hover:shadow-wager-green/30 hover:scale-105">
                                            <div className="text-center">
                                                <div className="flex justify-center gap-3 mb-6">
                                                    <SlotMachineIcon className="w-14 h-14 text-wager-green" />
                                                    <FootballIcon className="w-14 h-14 text-wager-green" />
                                                </div>
                                                <h3 className="text-3xl font-bold text-wager-green mb-3">100% Match</h3>
                                                <p className="text-white font-semibold mb-2">Casino & Sports</p>
                                                <p className="text-gray-400">Up to $1,000</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                {/* Monday Night Football */}
                                <div className="group">
                                    <a href="/monday-night-football" className="block h-full">
                                        <div className="h-full bg-gradient-to-br from-slate-700 to-slate-800 rounded-2xl p-10 border border-wager-green/30 hover:border-wager-green/60 transition-all duration-300 hover:shadow-2xl hover:shadow-wager-green/30 hover:scale-105">
                                            <div className="text-center">
                                                <div className="flex justify-center mb-6">
                                                    <FootballIcon className="w-16 h-16 text-wager-green" />
                                                </div>
                                                <h3 className="text-3xl font-bold text-wager-green mb-3">50% Match</h3>
                                                <p className="text-white font-semibold mb-2">Monday Night Football</p>
                                                <p className="text-gray-400">Up to $500 + Casino</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                {/* College Football */}
                                <div className="group">
                                    <a href="/college-football" className="block h-full">
                                        <div className="h-full bg-gradient-to-br from-slate-700 to-slate-800 rounded-2xl p-10 border border-wager-green/30 hover:border-wager-green/60 transition-all duration-300 hover:shadow-2xl hover:shadow-wager-green/30 hover:scale-105">
                                            <div className="text-center">
                                                <div className="flex justify-center mb-6">
                                                    <FootballIcon className="w-16 h-16 text-wager-green" />
                                                </div>
                                                <h3 className="text-3xl font-bold text-wager-green mb-3">75% Match</h3>
                                                <p className="text-white font-semibold mb-2">College Football</p>
                                                <p className="text-gray-400">Up to $750 + Casino</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                {/* NFL Sunday */}
                                <div className="group">
                                    <a href="/nfl-sunday" className="block h-full">
                                        <div className="h-full bg-gradient-to-br from-slate-700 to-slate-800 rounded-2xl p-10 border border-wager-green/30 hover:border-wager-green/60 transition-all duration-300 hover:shadow-2xl hover:shadow-wager-green/30 hover:scale-105">
                                            <div className="text-center">
                                                <div className="flex justify-center mb-6">
                                                    <FootballIcon className="w-16 h-16 text-wager-green" />
                                                </div>
                                                <h3 className="text-3xl font-bold text-wager-green mb-3">100% Match</h3>
                                                <p className="text-white font-semibold mb-2">NFL Sunday</p>
                                                <p className="text-gray-400">Up to $1,000 + Casino</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                {/* Crypto */}
                                <div className="group">
                                    <a href="/crypto-150" className="block h-full">
                                        <div className="h-full bg-gradient-to-br from-slate-700 to-slate-800 rounded-2xl p-10 border border-wager-green/30 hover:border-wager-green/60 transition-all duration-300 hover:shadow-2xl hover:shadow-wager-green/30 hover:scale-105">
                                            <div className="text-center">
                                                <div className="flex justify-center mb-6">
                                                    <LightningIcon className="w-16 h-16 text-wager-green" />
                                                </div>
                                                <h3 className="text-3xl font-bold text-wager-green mb-3">150% Match</h3>
                                                <p className="text-white font-semibold mb-2">Crypto Exclusive</p>
                                                <p className="text-gray-400">Up to $2,000</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                {/* Casino VIP */}
                                <div className="group">
                                    <a href="/casino" className="block h-full">
                                        <div className="h-full bg-gradient-to-br from-slate-700 to-slate-800 rounded-2xl p-10 border border-wager-green/30 hover:border-wager-green/60 transition-all duration-300 hover:shadow-2xl hover:shadow-wager-green/30 hover:scale-105">
                                            <div className="text-center">
                                                <div className="flex justify-center mb-6">
                                                    <SlotMachineIcon className="w-16 h-16 text-wager-green" />
                                                </div>
                                                <h3 className="text-3xl font-bold text-wager-green mb-3">200% Match</h3>
                                                <p className="text-white font-semibold mb-2">Casino VIP</p>
                                                <p className="text-gray-400">Up to $1,500</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* TRUST & SECURITY SECTION */}
                    <section className="bg-slate-900 py-20 border-t border-slate-700">
                        <div className="container mx-auto px-4">
                            <ScrollReveal direction="up" delay={0}>
                                <h2 className="text-5xl font-bold text-center text-white mb-16">
                                    Why Players Choose WagerStreet
                                </h2>
                            </ScrollReveal>
                            <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto">
                                <ScrollReveal direction="up" delay={100}>
                                    <div className="text-center">
                                        <div className="flex justify-center mb-6">
                                            <div className="w-16 h-16 rounded-full bg-wager-green/20 flex items-center justify-center">
                                                <LockIcon className="w-8 h-8 text-wager-green" />
                                            </div>
                                        </div>
                                        <h3 className="text-lg font-bold text-white mb-3">
                                            Licensed & Regulated
                                        </h3>
                                        <p className="text-gray-400 text-sm">
                                            Full compliance with gaming authorities worldwide
                                        </p>
                                    </div>
                                </ScrollReveal>
                                <ScrollReveal direction="up" delay={200}>
                                    <div className="text-center">
                                        <div className="flex justify-center mb-6">
                                            <div className="w-16 h-16 rounded-full bg-wager-blue/20 flex items-center justify-center">
                                                <LightningIcon className="w-8 h-8 text-wager-blue" />
                                            </div>
                                        </div>
                                        <h3 className="text-lg font-bold text-white mb-3">
                                            Instant Payouts
                                        </h3>
                                        <p className="text-gray-400 text-sm">
                                            Get winnings within 24 hours, no delays
                                        </p>
                                    </div>
                                </ScrollReveal>
                                <ScrollReveal direction="up" delay={300}>
                                    <div className="text-center">
                                        <div className="flex justify-center mb-6">
                                            <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center">
                                                <MoneyIcon className="w-8 h-8 text-purple-400" />
                                            </div>
                                        </div>
                                        <h3 className="text-lg font-bold text-white mb-3">
                                            Transparent Odds
                                        </h3>
                                        <p className="text-gray-400 text-sm">
                                            Verify fairness with blockchain technology
                                        </p>
                                    </div>
                                </ScrollReveal>
                                <ScrollReveal direction="up" delay={400}>
                                    <div className="text-center">
                                        <div className="flex justify-center mb-6">
                                            <div className="w-16 h-16 rounded-full bg-wager-green/20 flex items-center justify-center">
                                                <DiamondIcon className="w-8 h-8 text-wager-green" />
                                            </div>
                                        </div>
                                        <h3 className="text-lg font-bold text-white mb-3">
                                            VIP Rewards
                                        </h3>
                                        <p className="text-gray-400 text-sm">
                                            Loyalty program with exclusive perks
                                        </p>
                                    </div>
                                </ScrollReveal>
                            </div>
                        </div>
                    </section>
                </main>

                <Leaderboard />

                <Box bg={bgColor} color="white" p={isMobile ? 0 : 8} borderRadius="lg">
                    <div>
                        {isMobile ? (
                            // Mobile Layout
                            <VStack spacing={4} align="start" pt={4}>
                                {/* Left Section with Main Message */}
                                <Box>
                                    <Text color={textColor} fontSize="xl" fontWeight="bold" mb={4}>
                                        Wager more and see your rewards grow as a Wager Street VIP
                                    </Text>
                                    <Text color={textColor} fontSize="md" mb={4}>
                                        Step into a world of unique benefits, personalized service, and
                                        exclusive bonuses, only as a Wager Street VIP.
                                    </Text>
                                    <a href="https://wagerstreet.net/en?t=vipclub" target="_top" rel="noopener noreferrer">
                                        <Button colorScheme="#7FF800;" size="lg" w="100%">
                                            Become a VIP
                                        </Button>
                                    </a>

                                </Box>

                                {/* Right Section with Benefits */}
                                <VStack spacing={4} align="start" w="100%">
                                    <Flex
                                        bg="rgba(255, 255, 255, 0.1)"
                                        borderRadius="md"
                                        align="center"
                                        w="100%"
                                        p={2}
                                    >
                                        <Icon as={FaRocket} boxSize={8} color="red.500" mr={4} />
                                        <Box>
                                            <Text color={textColor} fontSize="lg" fontWeight="bold">
                                                Bonuses every week
                                            </Text>
                                            <Text color={textColor} fontSize="sm">
                                                Every week of each month, you’ll be rewarded with a bonus
                                                based on your recent games. The more you bet, the higher the
                                                bonuses.
                                            </Text>
                                        </Box>
                                    </Flex>

                                    <Flex
                                        bg="rgba(255, 255, 255, 0.1)"
                                        borderRadius="md"
                                        align="center"
                                        w="100%"
                                        p={2}
                                    >
                                        <Icon as={FaCrown} boxSize={8} color="red.500" mr={4} />
                                        <Box>
                                            <Text color={textColor} fontSize="lg" fontWeight="bold">
                                                Your Own VIP Host
                                            </Text>
                                            <Text color={textColor} fontSize="sm">
                                                Enjoy exclusive access to a dedicated VIP Host who will
                                                support and cater to your betting needs.
                                            </Text>
                                        </Box>
                                    </Flex>

                                    <Flex
                                        bg="rgba(255, 255, 255, 0.1)"
                                        borderRadius="md"
                                        align="center"
                                        w="100%"
                                        p={2}
                                    >
                                        <Icon as={FaTree} boxSize={8} color="red.500" mr={4} />
                                        <Box>
                                            <Text color={textColor} fontSize="lg" fontWeight="bold">
                                                Level Up Payouts
                                            </Text>
                                            <Text color={textColor} fontSize="sm">
                                                Get paid each time you reach a new level. The higher you go,
                                                the better the level-ups get.
                                            </Text>
                                        </Box>
                                    </Flex>

                                    <Flex
                                        bg="rgba(255, 255, 255, 0.1)"
                                        borderRadius="md"
                                        align="center"
                                        w="100%"
                                        p={2}
                                    >
                                        <Icon as={FaRedo} boxSize={8} color="red.500" mr={4} />
                                        <Box>
                                            <Text color={textColor} fontSize="lg" fontWeight="bold">
                                                Recent Play Bonuses
                                            </Text>
                                            <Text color={textColor} fontSize="sm">
                                                Looking to win back your unsuccessful wagers? Wager Street offers
                                                money back on losses every time you level up.
                                            </Text>
                                        </Box>
                                    </Flex>
                                </VStack>
                            </VStack>
                        ) : (
                            // Desktop Layout
                            <Flex justify="space-between" align="center">
                                {/* Left Section with Main Message */}
                                <Box maxW="50%">
                                    <Text color={textColor} fontSize="3xl" fontWeight="bold" mb={4}>
                                        Wager more and see your rewards grow as a Wager Street VIP
                                    </Text>
                                    <Text color={textColor} fontSize="lg" mb={6}>
                                        Step into a world of unique benefits, personalized service, and
                                        exclusive bonuses, only as a Wager Street VIP.
                                    </Text>
                                    <a href="https://wagerstreet.net/en?t=vipclub" target="_top" rel="noopener noreferrer">
                                        <Button colorScheme="#7FF800;" size="lg">
                                            Become a VIP
                                        </Button>
                                    </a>

                                </Box>

                                {/* Right Section with Benefits */}
                                <VStack spacing={4} align="start" width="50%">
                                    <Flex p={4} borderRadius="md" align="center" width="100%">
                                        <Icon as={FaRocket} boxSize={8} color="red.500" mr={4} />
                                        <Box>
                                            <Text color={textColor} fontSize="lg" fontWeight="bold">
                                                Bonuses every week
                                            </Text>
                                            <Text color={textColor} fontSize="sm">
                                                Every week of each month, youll be rewarded with a bonus
                                                based on your recent games. The more you bet, the higher the
                                                bonuses.
                                            </Text>
                                        </Box>
                                    </Flex>

                                    <Flex p={4} borderRadius="md" align="center" width="100%">
                                        <Icon as={FaCrown} boxSize={8} color="red.500" mr={4} />
                                        <Box>
                                            <Text color={textColor} fontSize="lg" fontWeight="bold">
                                                Your Own VIP Host
                                            </Text>
                                            <Text color={textColor} fontSize="sm">
                                                Enjoy exclusive access to a dedicated VIP Host who will
                                                support and cater to your betting needs.
                                            </Text>
                                        </Box>
                                    </Flex>

                                    <Flex p={4} borderRadius="md" align="center" width="100%">
                                        <Icon as={FaTree} boxSize={8} color="red.500" mr={4} />
                                        <Box>
                                            <Text color={textColor} fontSize="lg" fontWeight="bold">
                                                Level Up Payouts
                                            </Text>
                                            <Text color={textColor} fontSize="sm">
                                                Get paid each time you reach a new level. The higher you go,
                                                the better the level-ups get.
                                            </Text>
                                        </Box>
                                    </Flex>

                                    <Flex p={4} borderRadius="md" align="center" width="100%">
                                        <Icon as={FaRedo} boxSize={8} color="red.500" mr={4} />
                                        <Box>
                                            <Text color={textColor} fontSize="lg" fontWeight="bold">
                                                Recent Play Bonuses
                                            </Text>
                                            <Text color={textColor} fontSize="sm">
                                                Looking to win back your unsuccessful wagers? Wager Street offers
                                                money back on losses every time you level up.
                                            </Text>
                                        </Box>
                                    </Flex>
                                </VStack>
                            </Flex>
                        )}
                    </div>
                </Box>

                <Box
                    bg={bgColor}
                    color="white"
                    px={isMobile ? 0 : 8}
                    w="100%"
                    pb={20}
                >
                    <div>
                        {/* Grid Layout */}
                        <Grid templateColumns={{ base: "1fr", md: "1fr 2fr" }} gap={10}>
                            {/* Left Section: Text and Button */}
                            <Box px={isMobile ? 8 : 0} pt={isMobile ? 0 : 20}>
                                <Text color={textColor} fontSize="3xl" fontWeight="bold" mb={4}>
                                    Still have questions?
                                </Text>
                                <a href="https://wagerstreet.net/en/livesupport" target="_top" rel="noopener noreferrer">
                                    <Button
                                        colorScheme="#1475e1;"
                                        size={{ base: "md", md: "lg" }} // Adjust button size for mobile
                                    >
                                        Live Support
                                    </Button>
                                </a>
                            </Box>

                            {/* Right Section: Accordion FAQ */}
                            <Accordion allowMultiple={false}>
                                <AccordionItem>
                                    <h2>
                                        <AccordionButton color={textColor}>
                                            <Box flex="1" textAlign="left">
                                                Who is Wager Street?
                                            </Box>
                                            <AccordionIcon />
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel color={secondaryTextColor} pb={4}>
                                        Wager Street is a leading online gaming platform with a wide variety of
                                        betting options.
                                    </AccordionPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <h2>
                                        <AccordionButton color={textColor}>
                                            <Box flex="1" textAlign="left">
                                                Is Wager Street licensed?
                                            </Box>
                                            <AccordionIcon />
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel color={secondaryTextColor} pb={4}>
                                        Yes, Wager Street operates under a legitimate gaming license ensuring
                                        player safety and fair play.
                                    </AccordionPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <h2>
                                        <AccordionButton color={textColor}>
                                            <Box flex="1" textAlign="left">
                                                Is betting on Wager Street safe?
                                            </Box>
                                            <AccordionIcon />
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel color={secondaryTextColor} pb={4}>
                                        Betting on Wager Street is safe thanks to advanced encryption and a
                                        strong privacy policy.
                                    </AccordionPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <h2>
                                        <AccordionButton color={textColor}>
                                            <Box flex="1" textAlign="left">
                                                What currencies can I bet with?
                                            </Box>
                                            <AccordionIcon />
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel color={secondaryTextColor} pb={4}>
                                        You can bet using various cryptocurrencies including Bitcoin,
                                        Ethereum, and more.
                                    </AccordionPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <h2>
                                        <AccordionButton color={textColor}>
                                            <Box flex="1" textAlign="left">
                                                What types of casino games can I play?
                                            </Box>
                                            <AccordionIcon />
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel color={secondaryTextColor} pb={4}>
                                        Wager Street offers a wide range of casino games including slots,
                                        blackjack, roulette, and more.
                                    </AccordionPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <h2>
                                        <AccordionButton color={textColor}>
                                            <Box flex="1" textAlign="left">
                                                What sports can I bet on?
                                            </Box>
                                            <AccordionIcon />
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel color={secondaryTextColor} pb={4}>
                                        You can bet on a variety of sports including football,
                                        basketball, UFC, and more.
                                    </AccordionPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <h2>
                                        <AccordionButton color={textColor}>
                                            <Box flex="1" textAlign="left">
                                                How do I watch live streams?
                                            </Box>
                                            <AccordionIcon />
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel color={secondaryTextColor} pb={4}>
                                        Live streams can be watched directly on Wager Street platform for
                                        various events.
                                    </AccordionPanel>
                                </AccordionItem>
                            </Accordion>
                        </Grid>
                    </div>
                </Box>
            </Flex>
        </>

    );
}
